import arLocale from '@/configs/locales/ar.json';
import azLocale from '@/configs/locales/az.json';
import cnLocale from '@/configs/locales/cn.json';
import deLocale from '@/configs/locales/de.json';
import enLocale from '@/configs/locales/en.json';
import esLocale from '@/configs/locales/es.json';
import faLocale from '@/configs/locales/fa.json';
import frLocale from '@/configs/locales/fr.json';
import idLocale from '@/configs/locales/id.json';
import jpLocale from '@/configs/locales/jp.json';
import krLocale from '@/configs/locales/kr.json';
import kzLocale from '@/configs/locales/kz.json';
import plLocale from '@/configs/locales/pl.json';
import ptLocale from '@/configs/locales/pt.json';
import ruLocale from '@/configs/locales/ru.json';
import trLocale from '@/configs/locales/tr.json';
import uzLocale from '@/configs/locales/uz.json';
import { isTelegramApp } from '@/utils/isTelegramApp';
import { storage } from '@/utils/storage';
import i18n from 'i18next';

import { retrieveLaunchParams } from '@telegram-apps/sdk-react';
import { initReactI18next } from 'react-i18next';

export const LANG_TO_LOCALE_MAP = {
  ar: {
    translation: arLocale,
  },
  de: {
    translation: deLocale,
  },
  es: {
    translation: esLocale,
  },
  fr: {
    translation: frLocale,
  },
  id: {
    translation: idLocale,
  },
  tr: {
    translation: trLocale,
  },
  en: {
    translation: enLocale,
  },
  ru: {
    translation: ruLocale,
  },
  fa: {
    translation: faLocale,
  },
  az: {
    translation: azLocale,
  },
  cn: {
    translation: cnLocale,
  },
  jp: {
    translation: jpLocale,
  },
  kr: {
    translation: krLocale,
  },
  kz: {
    translation: kzLocale,
  },
  pl: {
    translation: plLocale,
  },
  pt: {
    translation: ptLocale,
  },
  uz: {
    translation: uzLocale,
  },
};

export const initI18n = async () => {
  const lang = await storage.getItem('lang');
  if (lang === '') {
    await storage.setItem(
      'lang',
      isTelegramApp()
        ? (retrieveLaunchParams().initData?.user?.languageCode ?? 'en')
        : 'en',
    );
  }
  const lng = lang === 'ua' ? 'ru' : lang;

  (i18n as any).use(initReactI18next).init({
    resources: LANG_TO_LOCALE_MAP,
    lng,
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false,
    },
  });
};
